/** @format */

import { useEffect, useState } from "react";
import { useMapContext } from "../../context/MapContext";
import StoreItem from "./StoreItem";
export default function StoreList() {
  const { userCoords } = useMapContext();
  const [itemAmount, setItemAmount] = useState(10);

  useEffect(() => {
    const storeList = document.getElementById("storeList");
    function handleScroll() {
      if (storeList.scrollTop + storeList.offsetHeight >= storeList.scrollHeight - 10) {
        setItemAmount((prev) => {
          return prev + 10;
        });
      }
    }
    storeList.addEventListener("scroll", handleScroll);

    return () => {
      storeList.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if(userCoords !== null)
    setItemAmount(10);
    if (userCoords !== null) setItemAmount(10);
    const storeList = document.getElementById("storeList");
    storeList.scrollTo({ top: 0, behavior: "smooth" })

  }, [userCoords]);

  const { filteredMarkers } = useMapContext();
  return (
    <section className="overflow-y-auto overflow-x-hidden customScrollBar pr-2 h-full" id="storeList">
      {filteredMarkers
        .slice()
        .sort((a, b) => a.distance - b.distance)
        .slice(0, itemAmount)
        .map((marker) => (
          <StoreItem key={"listItem" + marker.id} marker={marker} />
        ))}
    </section>
  );
}
